import { render } from "./IconNetwork.vue?vue&type=template&id=3d575ef9"
const script = {}
script.render = render

export default script